/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
var setupArticles = function setupArticles() {
  // get all reference from content
  function getReferencesFromContent(content) {
    var refID = [];
    var refsHash = content.textContent.match(/(REF#[0-9]*)/g);
    if (refsHash == null) {
      return refID;
    } else {
      var refs = content.textContent.match(/(REF#[0-9]*)/g).map(function (ref) {
        return parseInt(ref.split('#')[1]);
      });

      // remove duplicate id
      var uniqueArray = [];
      for (var _i = 0; _i < refs.length; _i++) {
        if (uniqueArray.indexOf(refs[_i]) === -1) {
          uniqueArray.push(refs[_i]);
        }
      }

      // set index for id
      var i = uniqueArray.length;
      uniqueArray.sort(function (a, b) {
        return b - a;
      }).forEach(function (id) {
        refID.push({
          id: id,
          index: i--
        });
      });
    }
    return refID;
  }

  // generate reference from tags
  function generateContent(content, refList, refIDs) {
    var modifiedContent = content.innerHTML;
    refIDs.forEach(function (ref) {
      var refHash = 'REF#' + ref.id;
      var regex = new RegExp(refHash, 'g');
      modifiedContent = modifiedContent.replace(regex, createSupElement(refList, ref));
    });
    content.innerHTML = modifiedContent;
  }

  // create superscript element
  function createSupElement(refList, ref) {
    var content = '';
    var refItem = refList.querySelector('[data-reference-id="' + ref.id + '"] .blog-reference-sup');
    if (refItem) {
      content = refItem.innerHTML;
    }
    return content;
  }

  // rearrange reference and hide unused reference
  function referenceListRearrange(refIDs, refList) {
    var listItems = refList.querySelectorAll('li');
    listItems.forEach(function (item) {
      refIDs.forEach(function (ref) {
        if (item.getAttribute('data-reference-id') == ref.id) {
          item.classList.add('show-reference');
        }
      });
    });
    var sortedList = refList.querySelectorAll('li.show-reference');
    sortedList.forEach(function (item, index) {
      item.querySelector('.blog-reference .blog-reference__id').innerHTML = index + 1 + '.';
      item.querySelector('.blog-reference-sup .reference__sup').innerHTML = index + 1;
      item.querySelector('.blog-reference-sup .blog-reference__id').innerHTML = index + 1 + '.';
    });
  }

  // clear REF#... from article content
  function clearReferenceFromContent() {
    var content = document.querySelector('.article-content .article-content-main');
    var refsID = getReferencesFromContent(content);
    var modifiedContent = content.innerHTML;
    refsID.forEach(function (ref) {
      var refHash = 'REF#' + ref.id;
      var regex = new RegExp(refHash, 'g');
      modifiedContent = modifiedContent.replace(regex, '');
    });
    content.innerHTML = modifiedContent;
  }

  // display reference on hover element
  function createDisplayOnHover(content) {
    var references = content.querySelectorAll('.reference');
    references.forEach(function (ref) {
      ref.addEventListener('mouseover', function () {
        var windowWidth = document.querySelector('body').clientWidth;
        this.classList.add('active');
        var refContent = this.querySelector('.reference__content');
        var position = getReferencePosition(refContent);
        if (position.right > windowWidth) {
          refContent.style.left = windowWidth - position.right - 5 + 'px';
        } else if (position.left < 0) {
          refContent.style.left = Math.abs(position.left) + 10 + 'px';
        }
      });
      ref.addEventListener('mouseout', function () {
        var refContent = this.querySelector('.reference__content');
        this.classList.remove('active');
        refContent.removeAttribute('style');
      });
    });
  }

  // get position of reference content
  function getReferencePosition(refContent) {
    var rect = refContent.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      right: rect.right + window.scrollX
    };
  }

  // init blog citations
  function init() {
    var refList = document.querySelector('ul.bm-blog-references');
    if (refList) {
      var content = document.querySelector('.article-content .article-content-main');
      var refIDs = getReferencesFromContent(content);
      referenceListRearrange(refIDs, refList);
      generateContent(content, refList, refIDs);
      createDisplayOnHover(content);
    } else {
      clearReferenceFromContent();
    }
  }
  init();
};
setupArticles();
/******/ })()
;